import { createApp } from 'vue'
import App from '../milestones/App.vue'
import { createPinia } from 'pinia';
import { router } from '../milestones/helpers';
import './milestones.css'
import Notifications from 'notiwind'
import { VueQueryPlugin } from '@tanstack/vue-query'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Notifications)
app.use(VueQueryPlugin)

app.mount('#app')